import React from "react";

export const StatusBadge = ({ status }) => {
  const map = {
    Success: "ks-badge-success",
    Pending: "ks-badge-pending",
    Failed: "ks-badge-failed",
  };
  const cls = map[status] || "";
  return <span className={`ks-badge ${cls}`} data-testid={`status-badge-${status}`}>{status}</span>;
};

export const MethodPill = ({ method }) => (
  <span className="ks-badge" style={{ background: "#f0f4f9", color: "#3f4e6b" }}>{method}</span>
);
